import { ActivityType } from 'types/interfaces/activity';
import {
  faHeart,
  faArrowUp,
  faPlus,
  faArrowDown,
  faTruck,
  faCheckCircle,
} from '@fortawesome/free-solid-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export interface ActivityTypeConfig {
  label: string;
  tooltip: string;
  color: string;
  bgColor: string;
  borderColor: string;
  icon: IconDefinition;
}

export const ACTIVITY_TYPE_CONFIG: Record<ActivityType, ActivityTypeConfig> = {
  available: {
    label: 'Affordable',
    tooltip: 'Wanted cards the receiver can currently afford, so the trade can complete',
    color: '#2ECC71',
    bgColor: 'rgba(46, 204, 113, 0.12)',
    borderColor: 'rgba(46, 204, 113, 0.40)',
    icon: faCheckCircle,
  },
  want_added: {
    label: 'Wanted',
    tooltip: 'All cards recently added to want lists regardless of affordability',
    color: '#E02CDC',
    bgColor: 'rgba(224, 44, 220, 0.12)',
    borderColor: 'rgba(224, 44, 220, 0.40)',
    icon: faHeart,
  },
  trade_sent: {
    label: 'Sent',
    tooltip: 'Cards recently sent to other traders',
    color: '#DD5BEA',
    bgColor: 'rgba(221, 91, 234, 0.12)',
    borderColor: 'rgba(221, 91, 234, 0.40)',
    icon: faArrowUp,
  },
  card_added: {
    label: 'Added',
    tooltip: 'Cards recently added to trades',
    color: '#C769EB',
    bgColor: 'rgba(199, 105, 235, 0.12)',
    borderColor: 'rgba(199, 105, 235, 0.40)',
    icon: faPlus,
  },
  trade_shipped: {
    label: 'Shipped',
    tooltip: 'Trade packages recently marked as shipped',
    color: '#8D37A7',
    bgColor: 'rgba(141, 55, 167, 0.12)',
    borderColor: 'rgba(141, 55, 167, 0.40)',
    icon: faTruck,
  },
  trade_received: {
    label: 'Received',
    tooltip: 'Trade packages recently marked as received',
    color: '#8409D3',
    bgColor: 'rgba(132, 9, 211, 0.12)',
    borderColor: 'rgba(132, 9, 211, 0.40)',
    icon: faArrowDown,
  },
};

/** WebSocket-driven activity types (used for socket event handling) */
export const ALL_ACTIVITY_TYPES: ActivityType[] = [
  'want_added',
  'trade_sent',
  'card_added',
  'trade_shipped',
  'trade_received',
];

/** Display order for filter pills (includes non-WebSocket types like 'available') */
export const FILTER_DISPLAY_ORDER: ActivityType[] = [
  'available',
  'want_added',
  'trade_sent',
  'card_added',
  'trade_shipped',
  'trade_received',
];

/** Default active filters on first visit */
export const DEFAULT_ACTIVE_TYPES: ActivityType[] = ['available'];
